import React, { useRef, useState, useContext } from "react";
import PropTypes from "prop-types";
import { store } from "~/Context/JukeboxContext";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay, faPause } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import classNames from "classnames";
import TrackImage from "./TrackImage";
import { mediaType } from "./../../../utils/media";

export const MediaPlayTrackWrapper = styled.section`
  /* display: block; */
  text-align: center;
  position: relative;
  /* display: inline-block; */
  .pause-icon,
  .play-icon {
    color: #fff;
  }
  .mediaImageMax {
    max-width: 300px;
    width: 100%;
  }
  .youtube-button {
    position: absolute;
    top: 44%;
    left: 0;
    right: 0;
    display: block;
    width: 70px;
    height: 50px;
    margin: 0 auto;
    text-align: center;
    /* border: 1px solid white; */
    border-radius: 13px;
    &:hover {
      box-shadow: 0px 1px 6px 0 #333;
    }
    button {
      outline: 0;
      border-radius: 15px;
      /* padding: 10px 10px 10px 15px; */
      /* youtube red button color #bf2929; */
      background-color: #bf2929;
      width: 70px;
      height: 50px;
      border: 0;
      opacity: 0.9;
      padding: 0;
    }
  }
  .jukebox-player-wrapper {
    margin-top: 10px;
    text-align: left;
    width: 100%;
    /* max-width: 420px; */
    max-width: 366px;
    margin: 10px auto 0 auto;
    display: flex;

    .jukebox-player-button {
      display: inline-block;
      button {
        background-color: white;
        border-radius: 0;
        border: 1px solid #bfbfbf;
        width: 53px;
        height: 48px;
        margin-right: 4px;
        svg {
          color: #000;
        }
      }
    }
  }

  .jukebox-waveform {
    position: relative;
    display: inline-block;
    img {
      display: inline-block;
      color: #000;
      background-color: #000;
      border: 1px solid #ccc;
      height: 48px;
      width: 100%;
    }
    &.seekbarActive {
      &:hover {
        cursor: pointer;
      }
    }
  }
  .seekbar {
    /* width: 20%; */
    visibility: hidden;
    position: absolute;
    /* width: 0; */
    height: 48px;
    background-color: #f3a92a;
    opacity: 0.4;
    &:after {
      content: " ";
      width: 0;
      height: 48px;
      border-right: 1px solid #020000;
      position: absolute;
      right: 0;
      z-index: 50;
    }
  }
  .seekbarActive {
    visibility: visible;
  }
`;

const JukeboxPlayTrack = ({ track, layoutCols }) => {
  const audioFormatClassName = track.sc_url && `audio-format-${mediaType(track.sc_url)}` || 'audio-format-none';
  const theWaveform = useRef(null);
  const globalState = useContext(store);

  const {
    dispatch,
    state: { playing },
  } = globalState;

  const isThisTheCurrentTrack = () => globalState.state.currentTrack && globalState.state.currentTrack.id == track.id;
  const getTrackProgress = () => (isThisTheCurrentTrack() && playing ? globalState.state.progress : 0);

  const handleWavClick = (e) => {
    if (!isThisTheCurrentTrack() || !playing) return;

    const wavWidth = theWaveform.current.getBoundingClientRect().width;
    const wavClick = e.clientX - theWaveform.current.getBoundingClientRect().left;
    const progress = parseFloat(wavClick / wavWidth); // ex: .5 is half way
    dispatch({ type: "track_seek", seekTo: progress });
  };

  const playTrack = async () => {
    if (playing && isThisTheCurrentTrack()) {
      dispatch({ type: "pause" });
    } else {
      await axios.get(`//www.dreamchimney.com/api/playlist-track?id=${track.id}`).then(({ data }) => {
        if (data && data[0] && data[0].tracks.length) dispatch({ type: "play_playlist", playlist: data[0] });
      });
    }
  };

  if (!track) return null;

  const mediaImage = classNames({
    mediaImageMax: !layoutCols,
    "center-block": true,
    "img-fluid": true,
  });

  const jukeboxPlayerWrapper = classNames({
    "jukebox-player-wrapper": true,
  });

  const seekBarClasses = classNames({
    seekbarActive: getTrackProgress() > 0,
    seekbar: true,
  });

  // controls hover mouse hand for seek
  const jukeboxWaveWrapperClasses = classNames({
    seekbarActive: playing && getTrackProgress() > 0,
    "jukebox-waveform": true,
  });

  return (
    <MediaPlayTrackWrapper className={audioFormatClassName}>
      <TrackImage track={track} link={false} className={mediaImage} />
      <div className={jukeboxPlayerWrapper}>
        <div className="jukebox-player-button">
          <button onClick={playTrack} title="Play track in the jukebox below">
            {(playing && isThisTheCurrentTrack() && <FontAwesomeIcon className="pause-icon" icon={faPause} />) || (
              <FontAwesomeIcon className="play-icon" icon={faPlay} />
            )}
          </button>
        </div>
        <div className={jukeboxWaveWrapperClasses} onClick={(e) => handleWavClick(e)}>
          <div className={seekBarClasses} style={{ width: `${getTrackProgress()}%` }}></div>
          <img
            ref={theWaveform}
            src="/tracks/img/jukebox-player-waveform.png"
            title={playing ? `Click to seek` : `Press play to listen to this track`}
            alt="audio waveform"
            style={{ pointerEvents: "all" }}
          />
        </div>
      </div>
    </MediaPlayTrackWrapper>
  );
};

JukeboxPlayTrack.propTypes = {
  track: PropTypes.object,
};

export default JukeboxPlayTrack;
